module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('div', {
    staticClass: "wrapper weex-ct weex-div",
    style: (_vm._px2rem(_vm.wrapStyle, 75)),
    attrs: {
      "weex-type": "div"
    }
  }, [_c('div', {
    staticClass: "dof-result weex-ct weex-div",
    style: ({
      top: _vm._px2rem(_vm.setPaddingTop, 75),
      backgroundColor: _vm.bgColor_
    }),
    attrs: {
      "weex-type": "div"
    }
  }, [_c('figure', {
    staticClass: "result-image weex-el weex-image",
    style: (_vm._px2rem(_vm.imgStyle, 75)),
    attrs: {
      "aria-hidden": true,
      "src": _vm.resultType.pic,
      "data-img-src": _vm.resultType.pic,
      "weex-type": "image"
    }
  }), _vm._v(" "), _vm._t("text", [(_vm.resultType.content) ? _c('div', {
    staticClass: "result-content weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  }, [_c('p', {
    staticClass: "content-text weex-el weex-text",
    attrs: {
      "weex-type": "text"
    }
  }, [_vm._v(_vm._s(_vm.resultType.content))]), _vm._v(" "), (_vm.resultType.desc) ? _c('p', {
    staticClass: "content-text content-desc weex-el weex-text",
    attrs: {
      "weex-type": "text"
    }
  }, [_vm._v(_vm._s(_vm.resultType.desc))]) : _vm._e()]) : _vm._e()], {}), _vm._v(" "), _c('div', {
    staticClass: "result-button weex-ct weex-div",
    attrs: {
      "weex-type": "div",
      "data-evt-touchend": ""
    },
    on: {
      "touchend": function($event) {
        $event.stopPropagation();
        return _vm.handleTouchEnd($event)
      }
    }
  }, [_vm._t("button", [(_vm.resultType.button) ? _c('dof-button', {
    attrs: {
      "size": "medium",
      "btnStyle": {
        width: 'auto',
        overflow: 'hidden',
        minWidth: '240px',
        maxWidth: '480px'
      },
      "textStyle": {
        textOverflow: 'none',
        maxWidth: '418px',
        marginLeft: 0,
        textAlign: 'center'
      },
      "text": _vm.resultType.button,
      "data-evt-dofButtonClicked": ""
    },
    on: {
      "dofButtonClicked": _vm.onClick
    }
  }) : _vm._e()], {}), _vm._v(" "), (_vm.resultType.btnSubTitle) ? _c('p', {
    staticClass: "btn-sub-text weex-el weex-text",
    attrs: {
      "weex-type": "text",
      "data-evt-click": ""
    },
    on: {
      "click": _vm.$stopOuterA,
      "weex$tap": function($event) {
        $event.stopPropagation();
        return _vm.onSubClick($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.resultType.btnSubTitle))]) : _vm._e()], 2)], 2)]) : _vm._e()
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-44d44e58", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-44d44e58","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/dof-result/index.vue
// module id = 611
// module chunks = 0 1